/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCompanyByStaffDto } from '../models/CreateCompanyByStaffDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DefaultService {
    /**
     * @returns any
     * @throws ApiError
     */
    public static companiesStaffControllerCreateByStaff({
        requestBody,
    }: {
        requestBody: CreateCompanyByStaffDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/staff/new',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
